const getters = {
  // token
  token: state => state.app.token,
  // 用戶信息
  userInfo: state => state.app.userInfo,
  region: state => state.app.region,
  masterInfo: state => state.app.masterInfo,
  // 帳戶信息
  accountInfo: state => state.app.accountInfo,
  // 管理员账号
  adminUuid: state => state.app.adminUuid,
  // 官方帳號
  systemUuid: state => state.app.systemUuid,
  isPlayingVoice: state => state.master.isPlayingVoice,
  // 新游戏选择页
  guideDialogVisible: state => state.master.guideDialogVisible,
  showNewerReward: state => state.app.showNewerReward,
  newDiscount: state => state.app.newDiscount,
  showNewerRewardCheckTip: state => state.app.showNewerRewardCheckTip,
  toggleAdBox: state => state.app.showAdBox,
  showAdBox: state => state.app.showAdBox,
  abTest: state => state.app.abTest,
  // 红点信息
  redCircleInfo: state => state.app.redCircleInfo,
  // 我的常用技能列表
  myGames: state => state.app.myGames,
  // 全部游戏列表
  allGames: state => state.app.allGames,
  // 自定义热门游戏排序列
  allGameCustomList: state => state.app.allGameCustomList,
  // 用户的白名单权限
  userPermissions: state => state.app.whiteListUserPermissions,
  lockBodyScroll: state => state.app.lockBodyScroll,
  // 技能详情、个人详情展示的用户信息
  viewMasterInfo: state => state.app.viewMasterInfo,
  loadingViewMasterInfo: state => state.app.loadingViewMasterInfo,
  // 頭像框-守护位
  avatarBorder: state => state.app.avatarBorder,
  // 頭像框-用户等级
  avatarLevel: state => state.app.avatarLevel,
  // IM 會話列表已加載
  imDataReady: state => state.im.dataLoaded,
  imSdkReady: state => state.im.sdkReady,
  // IM 未读消息数量
  imUnreadMessageCount: state => state.im.unreadCount,
  // IM 当前选择的会话
  imCurrentConversation: state => state.im.selectedConversation,
  // IM 会话列表
  imConversationList: state => state.im.conversationList,
  // IM 消息列表
  imMessageList: state => state.im.messageListMap,
  commentGiftInfo: state => state.order.commentGiftInfo,
  // 極速約單
  quickOrderSkills: state => state.app.quickOrderSkills,
  quickOrderLegalTimes: state => state.app.quickOrderLegalTimes,
  newerCoupon(s, getters) {
    const uInfo = getters.userInfo || {};
    if (!uInfo.uuid) return 0;
    const couponList = getters.accountInfo.couponInfoList || [];
    const coupon = couponList.find(item => {
      return item.couponKind == 'NEWCOMER_EXPERIENCE' && item.couponStatus === 'EFFECT';
    });
    return coupon || 0;
  },
  // 用于极速约单新人优惠ab逻辑，单数保持原状
  newCouponAB(s, getters) {
    const info = getters.userInfo || {}
    const uuid = info.uuid || 1
    return !(uuid % 2)
  },
  // uuid别名列表
  aliasList: state => state.app.aliasList,
}

export default getters
